(function () {
    var typed = '';
    var TRIGGER = 'holden';
    var vultureTimer = null;
    var bloodTimer = null;
    var closeBtn = null;
    var horizon = null;

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; startMeridian(); }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/blood-meridian')) {
        applyMeridianTheme();
        setTimeout(startMeridian, 600);
    }

    function applyMeridianTheme() {
        document.body.classList.add('meridian-active');

        var bgQuote = document.createElement('div');
        bgQuote.className = 'meridian-bg-quote';
        bgQuote.innerHTML = '<span>„Whatever in creation exists without my knowledge exists without my consent."</span>'
            + '<cite> — Judge Holden</cite>';
        document.body.appendChild(bgQuote);

        horizon = document.createElement('div');
        horizon.className = 'meridian-horizon';
        horizon.innerHTML = '<svg viewBox="0 0 1440 140" preserveAspectRatio="none"'
            + ' width="100%" height="140" xmlns="http://www.w3.org/2000/svg">'
            + '<ellipse cx="720" cy="140" rx="680" ry="90" fill="rgba(160,25,8,0.18)"/>'
            + '<ellipse cx="720" cy="140" rx="420" ry="60" fill="rgba(190,35,10,0.12)"/>'
            + '<path d="M0,140 Q320,96 640,112 Q880,124 1120,100 Q1300,84 1440,96 L1440,140 Z"'
            + ' fill="rgba(28,6,2,0.92)"/>'
            + '<path d="M0,140 Q200,122 440,132 Q680,142 900,126 Q1120,110 1440,128 L1440,140 Z"'
            + ' fill="rgba(14,3,1,0.98)"/>'
            + '</svg>';
        document.body.appendChild(horizon);
    }

    function startMeridian() {
        if (vultureTimer) return;
        document.body.classList.add('meridian-active');

        closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.style.cssText = 'position:fixed;top:1rem;right:1.2rem;z-index:10001;';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', stopMeridian);
        document.body.appendChild(closeBtn);

        spawnVulture();
        scheduleVultures();
        spawnBlood();
        scheduleBlood();
    }

    function scheduleVultures() {
        vultureTimer = setTimeout(function () {
            if (!vultureTimer) return;
            spawnVulture();
            if (Math.random() < 0.25) setTimeout(spawnVulture, 1200 + Math.random() * 1800);
            scheduleVultures();
        }, 6000 + Math.random() * 5000);
    }

    function scheduleBlood() {
        bloodTimer = setTimeout(function () {
            if (!bloodTimer) return;
            spawnBlood();
            if (Math.random() < 0.35) setTimeout(spawnBlood, 250 + Math.random() * 400);
            scheduleBlood();
        }, 1800 + Math.random() * 2400);
    }

    function stopMeridian() {
        clearTimeout(vultureTimer); vultureTimer = null;
        clearTimeout(bloodTimer); bloodTimer = null;
        document.body.classList.remove('meridian-active');
        document.querySelectorAll('.meridian-vulture-outer, .meridian-blood, .meridian-bg-quote').forEach(function (el) { el.remove(); });
        if (horizon) { horizon.remove(); horizon = null; }
        if (closeBtn) { closeBtn.remove(); closeBtn = null; }
    }

    function spawnVulture() {
        var goLeft = Math.random() > 0.5;
        var speed  = 22 + Math.random() * 14;
        var w      = Math.round(100 + Math.random() * 70);
        var h      = Math.round(w * 0.3);
        var top    = 6 + Math.random() * 58;
        var drift  = Math.random() * 5;

        var outer = document.createElement('div');
        outer.className = 'meridian-vulture-outer';
        outer.style.cssText = 'position:fixed;top:' + top + '%;left:0;z-index:9998;pointer-events:none;';

        var carrier = document.createElement('div');
        carrier.className = 'meridian-vulture-carrier--' + (goLeft ? 'rtl' : 'ltr');
        carrier.style.animationDuration = speed + 's';

        var driftEl = document.createElement('div');
        driftEl.className = 'meridian-vulture-drift';
        driftEl.style.animationDelay = '-' + drift + 's';

        var bird = document.createElement('div');
        if (goLeft) bird.style.transform = 'scaleX(-1)';
        bird.innerHTML = makeVulture(w, h);

        driftEl.appendChild(bird);
        carrier.appendChild(driftEl);
        outer.appendChild(carrier);
        document.body.appendChild(outer);

        setTimeout(function () { if (outer.parentNode) outer.remove(); }, (speed + 0.5) * 1000);
    }

    function spawnBlood() {
        var el = document.createElement('div');
        el.className = 'meridian-blood';
        var size  = 5 + Math.random() * 5;
        var trail = Math.round(size * (3 + Math.random() * 4));
        var speed = 1.2 + Math.random() * 1.6;
        var x     = 3 + Math.random() * 94;

        el.style.cssText = 'position:fixed;top:-' + (trail + size + 4) + 'px;left:' + x + '%;'
            + 'z-index:9999;pointer-events:none;'
            + 'animation-duration:' + speed + 's;';

        var r = Math.round(size / 2);
        el.innerHTML = '<svg width="' + size + '" height="' + (trail + size + 2) + '"'
            + ' viewBox="0 0 ' + size + ' ' + (trail + size + 2) + '"'
            + ' xmlns="http://www.w3.org/2000/svg">'
            + '<rect x="' + (r - 1) + '" y="0" width="2" height="' + trail + '" fill="rgba(130,5,5,0.88)" rx="1"/>'
            + '<ellipse cx="' + r + '" cy="' + (trail + r) + '" rx="' + r + '" ry="' + r + '" fill="rgba(150,8,8,0.92)"/>'
            + '</svg>';

        document.body.appendChild(el);
        setTimeout(function () { if (el.parentNode) el.remove(); }, (speed + 0.3) * 1000);
    }

    function makeVulture(w, h) {
        return '<svg viewBox="0 0 150 48" width="' + w + '" height="' + h + '"'
            + ' style="filter:drop-shadow(0 2px 6px rgba(180,20,5,0.55))"'
            + ' xmlns="http://www.w3.org/2000/svg">'
            + '<path d="M68,22 C54,13 34,5 4,14 C16,19 40,26 58,27 C63,27 66,25 68,22Z" fill="#7a2210"/>'
            + '<path d="M4,14 C2,10 0,8 2,6 C8,10 14,15 16,18Z" fill="#5a1a0c"/>'
            + '<path d="M82,22 C96,13 116,5 146,14 C134,19 110,26 92,27 C87,27 84,25 82,22Z" fill="#7a2210"/>'
            + '<path d="M146,14 C148,10 150,8 148,6 C142,10 136,15 134,18Z" fill="#5a1a0c"/>'
            + '<ellipse cx="75" cy="23" rx="11" ry="7" fill="#8a2a14"/>'
            + '<ellipse cx="89" cy="15" rx="7" ry="6.5" fill="#8a2a14"/>'
            + '<circle cx="91" cy="13" r="2" fill="#cc1a08"/>'
            + '<path d="M95,14 L103,16 L95,18Z" fill="#5a1a0c"/>'
            + '<path d="M64,27 L61,40 L67,35 L75,38 L83,35 L79,27" fill="#6a1c0c"/>'
            + '</svg>';
    }
})();
